<script lang="ts">
  import { fade } from "svelte/transition"

  import Spinner from "@components/Spinner.svelte"
  import asset from "@helpers/asset"

  export let image: {
    id: number
    exists: boolean
    path: string
    url: string
    is_featured: boolean
  }

  export let imageIndex: number
  export let imagesLength: number

  export let selectedImageId: number

  let imageUrl = ""
  let isImageLoaded = false

  $: if (image) {
    imageUrl = asset(image.url, {
      w: 100,
      h: 100,
    })
  }

  $: if (imageUrl) {
    isImageLoaded = false

    const imgEl = document.createElement("img")
    imgEl.onload = () => {
      isImageLoaded = true
    }

    imgEl.src = imageUrl
  }
</script>

<div>
  <span class="sr-only">View image {imageIndex + 1}</span>

  {#if isImageLoaded}
    <img transition:fade={{ duration: 300 }} src={imageUrl} alt="Image {imageIndex + 1} of {imagesLength}" />
  {:else}
    <div
      class="flex items-center justify-center absolute inset-0"
      in:fade={{ duration: 300, delay: 300 }}
      out:fade={{ duration: 300 }}
    >
      <Spinner class="text-beige-100" />
    </div>
  {/if}

  {#if selectedImageId === image.id}
    <span class="absolute inset-0 block bg-stroke bg-opacity-50" />
  {/if}
</div>
